import React from 'react'

import {
    SelectView,
} from './SelectView'

const Select = (props: any) => <SelectView {...props} />

export default Select
